/**
 * Insert Point Component
 * Shows blue line with + button on hover for inserting new containers
 */

import { Plus } from 'lucide-react';
import { useState } from 'react';

interface InsertPointProps {
  position: 'above' | 'below';
  containerPath: number[];
  rowIndex: number;
  onInsert: (containerPath: number[], rowIndex: number, position: 'above' | 'below') => void;
}

export function InsertPoint({ position, containerPath, rowIndex, onInsert }: InsertPointProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-full flex items-center justify-center"
      style={{ height: '24px', pointerEvents: 'none' }}
    >
      {/* Only the button area responds to hover and clicks - everything else is transparent */}
      <div
        className="relative"
        style={{ pointerEvents: 'auto' }}
        onMouseEnter={() => {
          console.log('🟢 Button area entered', { position, containerPath, rowIndex });
          setIsHovered(true);
        }}
        onMouseLeave={() => {
          console.log('🔵 Button area left');
          setIsHovered(false);
        }}
      >
        {/* Blue line - extends beyond button but has pointer-events: none */}
        {isHovered && (
          <div 
            className="absolute left-1/2 top-1/2 -translate-y-1/2 h-0.5 bg-primary pointer-events-none"
            style={{ width: '794px', marginLeft: '-397px' }}
          />
        )}
        
        {/* + Circle button */}
        <button
          onClick={(e) => {
            console.log('➕ Insert button clicked');
            onInsert(containerPath, rowIndex, position);
          }}
          className={`relative z-10 w-8 h-8 rounded-full bg-primary text-primary-foreground 
                     flex items-center justify-center
                     hover:bg-primary/90 transition-all
                     shadow-lg ${!isHovered ? 'opacity-0 scale-50' : 'opacity-100 scale-100'}`}
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
